// removed by extract-text-webpack-plugin
module.exports = {"discover-items":"discover-items___6YX-_","header":"header___14o8k","links":"links___YvrVu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DiscoverItems/DiscoverItems.scss
// module id = 4aul
// module chunks = 57